import styled from 'styled-components';

export const BMIContainerStyled = styled.div`
  .title_layout {
    margin-bottom: 19px;
    margin-left: 42px;
  }
`;
